/**
* Created by lobin on 2020/8/11.
*/
<template>
	<div class="recharge">
		<a-card :body-style="{padding: '24px 32px'}" :bordered="false">
			<a-form-model layout="inline" @submit="handleSearch" @submit.native.prevent>
				<a-form-model-item>
					<company-search
						v-model="search.company"
						placeholder="请选择所属公司"
					/>
				</a-form-model-item>
				<a-form-model-item>
          <a-select placeholder="选择类型" v-model="search.type" style="width: 120px;" allowClear>
            <a-select-option
              v-for="item in flowTypes"
              :key="item.value"
              :value="item.value">
              {{ item.name }}
            </a-select-option>
          </a-select>
      </a-form-model-item>
				<a-form-model-item>
					<a-range-picker v-model="range" placeholder="选择日期"  valueFormat="YYYY-MM-DD" />
				</a-form-model-item>
				<a-form-model-item>
					<a-button
						type="primary"
						html-type="submit"
						icon="search"
					>
						查询
					</a-button>
				</a-form-model-item>
			</a-form-model>
			<a-divider />
			<a-alert type="info" show-icon style="margin-bottom:20px;">
				<div slot="message">
					所选条件范围
					<span v-if="info.recharge">充值:{{ info.recharge }}</span>
					<span v-if="info.withdrawal">,提现:{{ info.withdrawal }}</span>
					<span v-if="info.consume">,系统费用:{{ info.consume }}</span>
					<span v-if="info.profit">,派费收益:{{ info.profit }}</span>
				</div>
			</a-alert>
			<a-table
				:loading="loading"
				:columns="columns"
				:data-source="list"
				:scroll="{y: $store.getters.listTableHeight - 80 }"
				:pagination="pager"
				rowKey="_id"
				@change="change">
				<span slot="isPay" slot-scope="text, record">
            <a-tag color="green" v-if="record.isPay">成功</a-tag>
            <a-tag color="red" v-else>失败</a-tag>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="modify(record._id)" v-has:modifyStation>
            修改
          </a>
          <a-divider type="vertical" />
          <a href="javascript:;" @click="showStationQrcode(record)">二维码</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link" @click="e => e.preventDefault()">
              更多<a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a href="javascript:;" @click="check(record)" v-has:stationCheck>检测</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
			</a-table>
		</a-card>
	</div>
</template>

<script type="text/babel">
import { companyconsume } from '@/api/company';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      search: {},
      list: [],
			pager: {},
			info: {},
			range: [],
      loading: false,
    };
  },
  created() {
    this.getList();
  },
  computed: {
		...mapGetters(['flowTypes']),
    columns() {
      return [
        {
				  title: '#',
				  dataIndex: 'index',
				  customRender: (text, row, index) => index + 1,
				  key: 'index',
				  width: '50px',
			  },
			  {
				  title: '公司名称',
				  dataIndex: 'company.name',
				  key: 'name',
			  },
	      {
		      title: '金额',
		      dataIndex: 'balance',
		      key: 'balance',
				},
				{
		      title: '余额',
		      dataIndex: 'account',
		      key: 'account',
				},
				{
		      title: '类型',
		      dataIndex: 'type',
		      key: 'type',
	      },
	      {
		      title: '日期',
		      dataIndex: 'day',
		      key: 'day',
	      },
	      {
		      title: '结果',
		      dataIndex: 'isPay',
		      key: 'isPay',
	        scopedSlots: { customRender: 'isPay' },
	      },
	      {
		      title: '时间',
		      dataIndex: 'ctime',
		      key: 'ctime',
	      },
		  ];
	  },
  },
  methods: {
  	async getList() {
			this.loading = true;
			this.search.ctimeStart = this.range[0];
      this.search.ctimeEnd = this.range[1];
  		const { data: { docs, pager, info } } = await companyconsume(this.search);
  		this.list = docs;
			this.pager = pager;
			this.info = info;
	    this.loading = false;
	  },
    change(pagination) {
      this.search.page = pagination.current;
      this.getList();
    },
    handleSearch() {
      this.getList();
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less">
	.recharge {

	}
</style>
